import * as leaflet from "leaflet";
export class OpacityGroup extends leaflet.FeatureGroup {
    constructor() {
        super();
        this.opacity = 1;
        this.children = [];
    }
    setOpacity(opacity) {
        this.opacity = opacity;
        this.getTooltip()?.setOpacity(opacity);
        function set(layer) {
            if (layer.layer instanceof OpacityGroup)
                layer.layer.setOpacity(opacity * layer.baseline.stroke);
            else if (layer.layer instanceof leaflet.Marker)
                layer.layer.setOpacity(opacity * layer.baseline.stroke);
            else if (layer.layer instanceof leaflet.Tooltip)
                layer.layer.setOpacity(opacity * layer.baseline.stroke);
            else if (layer.layer instanceof leaflet.Polyline) {
                // This hack is the reason this class exists at all.
                // Polylines (and by extension, Polygons) don't have a setOpacity method
                layer.layer.setStyle(Object.assign(layer.layer.options, {
                    opacity: opacity * layer.baseline.stroke,
                    fillOpacity: opacity * layer.baseline.fill,
                }));
            }
            layer.layer.getTooltip()?.setOpacity(opacity * layer.baseline.stroke);
        }
        this.children.forEach(set);
        return this;
    }
    addLayer(layer) {
        super.addLayer(layer);
        function get() {
            if (layer instanceof leaflet.Marker
                || layer instanceof leaflet.Tooltip)
                return {
                    stroke: layer.options.opacity
                };
            else if (layer instanceof OpacityGroup)
                return {
                    stroke: layer.opacity
                };
            else if (layer instanceof leaflet.Polyline)
                return {
                    stroke: layer.options.opacity,
                    fill: layer.options.fillOpacity
                };
            return { stroke: 1 };
        }
        this.children.push({
            layer: layer,
            baseline: get()
        });
        return this;
    }
    removeLayer(layer) {
        super.removeLayer(layer);
        this.children.splice(this.children.findIndex(c => c.layer == layer));
        return this;
    }
}
export class ActiveOpacityGroup extends OpacityGroup {
    constructor(active_opacity, inactive_opacity) {
        super();
        this.active_opacity = active_opacity;
        this.inactive_opacity = inactive_opacity;
        this.active = true;
    }
    setActive(v) {
        this.active = v;
        this.setOpacity(v ? this.active_opacity : this.inactive_opacity);
        return this;
    }
    isActive() {
        return this.active;
    }
}
